<template>
  <div class="">
    <div class="d-flex flex-row">
      <icd-autocomplete class="flex-grow-1"></icd-autocomplete>
      <admin-login class="flex-shrink-1"></admin-login>
    </div>
    <div class="ma-1 ma-sm-2">
      <!-- {{ search }} -->
      <v-fade-transition>
        <icd-chapter v-if="chapter"></icd-chapter>

        <icd-range
          v-else-if="codes"
          :search="codes"
          @aliases="aliases = $event"
        ></icd-range>
        <diabetes-widget v-else-if="diabetesWidget"></diabetes-widget>
        <diabetes-group
          v-else-if="group && group == 'diabetes'"
        ></diabetes-group>
        <icd-search-all v-else-if="search"></icd-search-all>
        <icd-collection
          v-else-if="collection"
          :collection="collection"
          @aliases="aliases = $event"
        ></icd-collection>
        <icd-chapters v-else-if="$route.name == 'CodeChapters'"></icd-chapters>
        <icd-home v-else></icd-home>
      </v-fade-transition>
    </div>
    <!-- {{ data }} -->
    <icd-alias-list v-if="aliases" class="my-2" :aliases="aliases">
    </icd-alias-list>
  </div>
</template>

<script>
import IcdAutocomplete from "../../components/icdStuff/IcdAutocomplete.vue";
import AdminLogin from "../../components/universalStuff/AdminLogin.vue";
export default {
  name: "icdBrowse",
  components: {
    IcdChapters: () => import("@/components/icdStuff/IcdChapters"),
    IcdChapter: () => import("@/components/icdStuff/IcdChapter"),
    IcdCollection: () => import("@/components/icdStuff/IcdCollection"),
    IcdRange: () => import("@/components/icdStuff/IcdRange"),
    IcdAliasList: () => import("@/components/icdStuff/IcdAliasList"),
    IcdSearchAll: () => import("@/components/icdStuff/IcdSearchAll"),
    IcdHome: () => import("@/components/icdStuff/IcdHome"),
    DiabetesWidget: () => import("@/components/icdStuff/DiabetesWidget"),
    DiabetesGroup: () => import("@/components/icdStuff/DiabetesGroup"),
    IcdAutocomplete,
    AdminLogin,
  },
  props: {
    title: null,
  },
  data: function () {
    return {
      data: null,
      error: false,
      loading: false,
      section: null,
      chapter: null,
      collection: null,
      group: null,
      code: null,
      codes: null,
      search: null,
      aliases: null,
      diabetesWidget: false,
    };
  },
  methods: {},
  computed: {},
  mounted: function () {
    // console.log(this.$route.params);
    if (this.$route.params.chapter) {
      this.chapter = this.$route.params.chapter;
      // } else if (this.$route.params.code) {
      //   this.codes = this.$route.params.code;
    } else if (this.$route.name == "diabetesWidget") {
      this.diabetesWidget = true;
    } else if (this.$route.params.range) {
      this.codes = this.$route.params.range;
    } else if (this.$route.params.search) {
      // if url is like /icd/search/foo
      this.search = this.$route.params.search;
    } else if (this.$route.query.q) {
      // if url is like /icd/search?q=foo
      this.search = decodeURIComponent(this.$route.query.q);
      // console.log(this.search);
    } else if (this.$route.params.collection) {
      this.collection = this.$route.params.collection;
    } else if (this.$route.params.group) {
      this.group = this.$route.params.group;
    }
  },
};
</script>

<style scoped></style>
